module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/thumbs-down-90b5ceb4950b5fb2a768d95610378b70.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/thumbs-down.svg
// module id = jFMy
// module chunks = 24